import React, { memo } from 'react';

import { bizComponents, bizUtils } from 'businessCommon';
const { ImgSpareTire } = bizComponents;
const { getCircleIndexUrl } = bizUtils;

import { ICircleResourceInfo } from 'market/@marketCommon/interface/recommend';

import './circleItem.scss';

interface IProps {
    resourceInfo: ICircleResourceInfo;
}

export const CircleItem = memo(({ resourceInfo }: IProps) => {
    const renderTags = (tags: string[]) => {
        return tags.map((tag, i) => (
            <div key={`tag_${i}`} className="tag">
                {tag}
            </div>
        ));
    };

    const render = () => {
        const tags = (resourceInfo.m_tag_list || []).slice(0, 3);
        const coverUrl = resourceInfo.m_cover_url || resourceInfo.cover_url || '';
        return (
            <a
                target="_blank"
                className="circle-recommend-item"
                href={getCircleIndexUrl(resourceInfo.encrypted_id)}
                rel="noreferrer"
            >
                <ImgSpareTire src={coverUrl} />
                <div className="info">
                    <div className="title umu-text-clamp clamp-2">
                        {resourceInfo.m_obj_title || resourceInfo.obj_title}
                    </div>
                    <div className="recommend-desc umu-text-clamp clamp-1">
                        {resourceInfo.m_recommend_desc || resourceInfo.recommend_desc}
                    </div>
                    <div className="owner-desc umu-text-clamp clamp-1">
                        {resourceInfo.m_owner_name || resourceInfo.owner_name}
                        <span className="desc">{resourceInfo.m_owner_desc || resourceInfo.owner_desc}</span>
                    </div>
                    <div className="tags clearfix">{renderTags(tags)}</div>
                </div>
            </a>
        );
    };

    return render();
});
